var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTaskBook = function SvgTaskBook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#FDC469",
    rx: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20.462 12.48v16.75c1.53-.145 2.884-.168 4.182-.873l3.52-1.913c1.107-.602 1.528-1.64 1.528-2.643v-9.774c0-2.566-3.81-4.169-6.643-2.63-.825.449-1.621.952-2.587 1.083M19.538 29.23c-1.532-.145-2.647-.168-3.946-.873l-3.523-1.913c-1.109-.603-1.761-1.548-1.761-2.551V13.888c0-2.565 4.045-4.03 6.88-2.49.825.448 1.383.951 2.35 1.082z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#C3D3E5",
    d: "M19.539 12.49h.923v16.74h-.923z"
  })));
};
export { SvgTaskBook as ReactComponent };